import AnaliticsService from '@/api/AnaliticsService.js'
import Vue from 'vue'
export const analiticsModule = {
  namespaced: true,
  state: () => ({
    analiticsData: [],
    analiticsLoadStatus: 'request',
    paginationPromocodesStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationPromocodesStateParams.total /
        state.paginationPromocodesStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.analiticsData = [...data]
    },
    create(state, data) {
      state.analiticsData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.analiticsData.findIndex(
        (x) => x.Analitics__id == data.id
      )
      Object.assign(state.analiticsData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.analiticsData.findIndex((x) => x.Analitics__id == id)
      state.analiticsData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationPromocodesStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.analiticsLoadStatus = 'request'
    },
    load_success(state) {
      state.analiticsLoadStatus = 'success'
    },
    load_error(state) {
      state.analiticsLoadStatus = 'error'
    }
  },
  actions: {
    getAnaliticsAll({ commit }, params) {
      commit('load_request')

      AnaliticsService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createAnaliticsData({ commit }, createData) {
      AnaliticsService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editAnaliticsMultiple({ commit }, { id, dataEdit }) {
      AnaliticsService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteAnaliticsData({ commit }, id) {
      // commit("load_request");
      AnaliticsService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
